import {
  IonCol,
  IonGrid,
  IonIcon,
  IonRow,
  IonSegment,
  IonSegmentButton
} from "@ionic/react";
import { LoadMap } from "../../../components/app/LoadMap/LoadMap";
import React, { useEffect, useState } from "react";
import { isContactUsVisible } from '../../utils/ContactUsVisibilityUtil';
import { getSessionId, logEvent, setScreenName } from "../../../utils/Analytics";
import { EVENT, SCREEN, TAB } from "../../../utils/constants.analytics";
import {
  MODULES,
  isMyload,
  MYLOAD_DOCUMENT_UPLOAD,
  ESOURCE_TYPE_CHECK,
  CONTENT_OR_CONFIG_TABLE_MAPPING,
  EdivisionList,
  EsourceTMSList,
  CONTACT_DETAILS_NOT_FOUND
} from "../../../utils/constants";
import { MyloadStopDetails } from "./MyloadStopDetails";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import {
  isEntitled,
  LPEFeedbackWrapper,
  isCarrierGuest,
  IONICWrapper,
  SourceTMSValidation,
} from "../../../utils/common";
import Commodities from "../../../components/shared/Commodities/Commodities";
import Pay from "../../../components/shared/Pay/Pay";
import { handleBetaToolBtnClick } from "../../../components/app/ShipmentUpdateScreen/BetaToolsBtn";
import {
  getLoadCommodities,
  getLoadStopCommodities
} from "../../../components/shared/Commodities";
import References from "../../../components/shared/Commodities/References/References";
import { contactUsDetailsRequest, getTmsDocumentsRequest } from "../../../actions/myload/action";
import { ListDocumentsModel } from "../../../models/myLoad/listDocuments.model";
import Documents from "../../../components/shared/Documents/Documents";
import { validateDocumentContent } from "../../../components/shared/Documents/utils";
import { getShipmentDetails } from "../../../selectors/Myload/selector";
import { IEShipmentCostItem, IEShipmentResponse, IEShipmentStop } from "../../../schemas/getShipment/GetShipment.schema";
import Services from "../../../components/shared/Commodities/Services/Services";
import { ToastMessage } from "app/utils/ToastMessage";
import ContactUsModal from "app/components/shared/ContactUsModal/ContactUsModal";
import { getContactEventDetails } from "app/utils/ContactUsModal.util";
import { store } from "app/store";
export const approvedDocumentMaxSize: number = parseInt(
  (IONICWrapper.details.getKeyValuePairs(
    CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
  ) &&
    IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ).ADD_DOCUMENT_CONFIG &&
    IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ).ADD_DOCUMENT_CONFIG.maximumSize) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.maximumSize
);
const LoadTileMap = (props: any) => {
  const { t } = useTranslation();
  const [activeTab, updateTabName] = useState<string>(props.defaultTab || "map");
  const {
    show,
    loadStop = [],
    module,
    loadId,
    userDetails,
    rank,
    resultId,
    loadCommodityList
  } = props;
  const dispatch = useDispatch();
  const [documentsList, setDocumentsList] = useState<any>(null);
  const [documentsListLoader, setDocumentsListLoader] = useState<any>(true);
  const [selectedUploadDocumentType, setselectedUploadDocumentType] = useState(
    {}
  );
  const shipmentDetails: IEShipmentResponse = useSelector(getShipmentDetails());
  const loadStops = shipmentDetails
                            && shipmentDetails.shipments
                            && shipmentDetails.shipments.length > 0 
                            ? shipmentDetails.shipments[0].loadStop : [];
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactDetails, setContactDetails] = useState<any>(null);
  const storeData = store.getState();
  const session = storeData && storeData.App && storeData.App.session;
  const sessionId = getSessionId(session.uuid);
  const handleSelectedUploadDocumentTypeChange = (item: any) =>
    setselectedUploadDocumentType(item);
  const handleFileChange = (event: any) => {
    const fileObj = event.target.files;
    let result: any[] = [];
    if (fileObj.length > 0) {
      let temp = [...uploadedDocuments];
      if (temp.length === 0) {
        [...fileObj].forEach((item: any, index: number) => {
          if (validateDocumentContent(item)) {
            result.push({ rank: index + 1, content: item });
          }
        });
      } else {
        result = [...temp];
        [...fileObj].forEach((item: any, index: number) => {
          if (validateDocumentContent(item)) {
            result.push({ rank: temp.length + (index + 1), content: item });
          }
        });
      }
      setUploadedDocuments(result);
    }
  };

  const lead = () => {
    if (module === MODULES.SEARCH_RESULTS) {
      return TAB.SEARCHED;
    }
    if (module.indexOf(TAB.RECOMMENDED) !== -1) {
      return TAB.RECOMMENDED;
    }
    if (module.indexOf(TAB.WATCHED) !== -1) {
      return TAB.WATCHED;
    }
    if (module && module.indexOf(TAB.MANAGE_CAPACITY) !== -1) {
      return TAB.MANAGE_CAPACITY;
    }
    if (module && module.indexOf(TAB.CARRIER_ASSIGNED) !== -1) {
      return TAB.CARRIER_ASSIGNED; //lead //screen
    }
    if (module && module.indexOf(TAB.DRIVER_ASSIGNED) !== -1) {
      return TAB.DRIVER_ASSIGNED; //lead //screen
    }
    if (module && module.indexOf(TAB.IN_TRANSIT) !== -1) {
      return TAB.IN_TRANSIT; //lead //screen
    }
    if (module && module.indexOf(TAB.RECENTLY_DELIVERED_LOADS) !== -1) {
      return TAB.RECENTLY_DELIVERED_LOADS; //lead //screen
    }
  };

  const isShipmentExecution =
    module === MODULES.CARRIER_ASSIGNED_MODULE ||
    module === MODULES.DRIVER_ASSIGNED_MODULE ||
    module === MODULES.INTRANSIT_MODULE ||
    module === MODULES.RECENTLY_DELIVERED_MODULE ||
    module === MODULES.DELIVERED_WITH_PPWK_MODULE;
  useEffect(() => {
    setScreenName(SCREEN.LOAD_DETAILS);
    const logEventParams = {
      screen: SCREEN.LOAD_DETAILS_MAP,
      loadId,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      lead: lead(),
      rank: rank,
      resultId: resultId
    };
    if (activeTab === "map") {
      //Clicked on the arrow to show the details
      if (!isShipmentExecution) {
        LPEFeedbackWrapper.log(EVENT.UE_LOAD_DETAILS_MAP, {
          screen: SCREEN.LOAD_DETAILS_MAP,
          loadId: [props.loadId],
          lead: lead(),
          rank: rank,
          resultId: resultId
        });
      }
      // Analytics implementation
      logEvent(EVENT.SV_LOAD_DETAILS_MAP, logEventParams);
    } else if (activeTab === "commodities") {
      const eventName = loadCommodityList
        ? EVENT.UE_LOAD_POSTING_COMMODITIES_VIEW
        : EVENT.UE_SHIPMENT_EXECUTION_COMMODITIES_VIEW;
      logEvent(eventName, logEventParams);
    } else if (activeTab === "pay") {
      const shipmentId = (props && props.shipmentId) || "";
      const carrierId = (userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId) || "";
      const roles =
        (userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.userApplicationDetails[0] &&
          userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles) ||
        [];
      logEvent(EVENT.UE_LOAD_AGREED_RATE, {
        screen: SCREEN.LOAD_DETAILS_AGREED_RATE,
        shipmentId,
        carrierId:userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        roles
      });
    } else if (activeTab === "documents") {
      if (documentsList === null) {
        handleDocumentFetch();
      }
    }
  }, [activeTab]);

  const handleDocumentFetch = (activateLoading = false) => {
    activateLoading && setDocumentsListLoader(true);
    const shipmentId = (props && props.shipmentId) || "";
    const sourceTms = (props && props.sourceTMS) || "";
    const orderId =shipmentDetails && shipmentDetails.shipments && shipmentDetails.shipments.length > 0 ? shipmentDetails.shipments[0].orderId : "";
    const model = new ListDocumentsModel();
    model.shipmentId = shipmentId;
    model.sourceTms = sourceTms;
    model.orderId = orderId;
    const callback = (data: any) => {
      const documents = (data && data.documents) || [];
      const relatedDocuments = (data && data.relatedDocuments) || [];
      setDocumentsList({ documents, relatedDocuments });
      setDocumentsListLoader(false);
    };
    dispatch(
      getTmsDocumentsRequest({ query: model.getListDocuments(), callback })
    );
  };

  const totalReferences = shipmentDetails && shipmentDetails.shipments && shipmentDetails.shipments.length > 0 ? shipmentDetails.shipments[0].shipmentReferences : [] ;
  const shipmentServices = shipmentDetails && shipmentDetails.shipments && shipmentDetails.shipments.length > 0 ? shipmentDetails.shipments[0].shipmentServices : [] ;
  const shipmentCostItems : IEShipmentCostItem[] = shipmentDetails && shipmentDetails.shipments && shipmentDetails.shipments.length > 0 ? shipmentDetails.shipments[0].shipmentCostItems : [] ;
  const isServicesAvailable = shipmentServices?.length > 0 ? true : false;
  const costCurrency = props.load.costCurrency || "USD";
  const totalCostAmount = props.load.totalCostAmount || 0;
  const isReferencesTab =
    module === MODULES.DRIVER_ASSIGNED_MODULE ||
    module === MODULES.INTRANSIT_MODULE ||
    module === MODULES.RECENTLY_DELIVERED_MODULE ||
    module === MODULES.DELIVERED_WITH_PPWK_MODULE;

  const tabNamesByModule = [{ name: "Map", key: "map" }];
  !isCarrierGuest() && module.includes("MyLoad") &&
    tabNamesByModule.push({ name: "Commodities", key: "commodities" });
    !isCarrierGuest() && module.includes("MyLoad") && isServicesAvailable &&
    tabNamesByModule.push({ name: "Services", key: "services" });
  isReferencesTab &&
    tabNamesByModule.push({ name: "References", key: "references" });
  isMyload(module) &&
    isEntitled("myLoad", "documentList") &&
    module != MODULES.CARRIER_TENDERED_MODULE &&
    SourceTMSValidation(props.load.sourceTMS as EsourceTMSList,props.load.division as EdivisionList,ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE) &&
    tabNamesByModule.push({ name: "Documents", key: "documents" });
  isMyload(module) &&
    isEntitled("myLoad", "rateDetails") &&
    tabNamesByModule.push({ name: "Pay", key: "pay" });

  const getSortedLoadStops = (stops: any) => {
    let sortedStops = stops.slice().sort((stop1: any, stop2: any) => {
      if (stop1.sequenceNo && stop2.sequenceNo)
        return stop1.sequenceNo - stop2.sequenceNo;
      if (stop1.stopSequence && stop2.stopSequence)
        return stop1.stopSequence - stop2.stopSequence;
      return 0;
    });
    return sortedStops;
  };

  const sortedLoadStops: IEShipmentStop[] = getSortedLoadStops(isMyload(module)?loadStops:loadStop);
  const commodities = getLoadStopCommodities(sortedLoadStops);
  return <>
   {isContactModalOpen &&   <ContactUsModal
        isOpen={isContactModalOpen}
        onClosed={() => setIsContactModalOpen(false)}
        contactDetails={contactDetails}/>}
        
     {show ? (
    <IonGrid className="load-map-grid">
      <IonRow className="group-tab">
        <IonCol size="8">
          {tabNamesByModule && tabNamesByModule.length && (
            <IonSegment
              mode="ios"
              onIonChange={(e?: any) => {
                updateTabName(e.detail.value);
              }}
              class="references-tabPanel ion-segment-load-tile-map"
              data-testid="tab-panel"
              value={activeTab}
            >
              {tabNamesByModule.map(tab => {
                return (
                  <IonSegmentButton mode="ios" key={tab.key} value={tab.key}>
                    <div className="segment-title" data-testid={tab.key}>
                      {tab.name}
                    </div>
                  </IonSegmentButton>
                );
              })}
            </IonSegment>
          )}
        </IonCol>
        {isMyload(module) &&
          module !== MODULES.CARRIER_ASSIGNED_MODULE &&
          isEntitled("myLoad", "betaTools") && (
            <IonCol size="2">
              <div className="beta-tool-link">
                <span
                  data-testid="beta-tool-button"
                  onClick={() => {
                    handleBetaToolBtnClick(props.shipmentId || props.loadId);
                  }}
                >
                  <IonIcon src="assets/icon/betaTool.svg" />
                  <span>Beta Tools</span>
                </span>
              </div>
            </IonCol>
          )
        }
        <IonCol
          size={`${
            isMyload(module) &&
            module !== MODULES.CARRIER_ASSIGNED_MODULE &&
            isEntitled("myLoad", "betaTools")
              ? "2"
              : "4"
          }`}
        >
        {isContactUsVisible(module) && 
          <div className="call-us-link">
            <span
              data-testid="call-us-button"
              onClick={() => {
                const callback = (responseType: string, data: any) => {
                  if (responseType === "success") {
                   setIsContactModalOpen(true)
                   setContactDetails(data?.message)
                   logEvent(getContactEventDetails(props?.module).eventName, {
                    screen: getContactEventDetails(props?.module).screenName,
                    loadId: props.shipmentId || props.loadId,
                    lead: getContactEventDetails(props?.module).screenName,
                    sessionId :sessionId
                  });
                  } else {
                   ToastMessage.showWeb(CONTACT_DETAILS_NOT_FOUND);
                 }
                 };
                 const payload = props.shipmentId || props.loadId;
                 dispatch(contactUsDetailsRequest({
                   query: payload,
                   callback
                 }))
              }}
            >
              <div className="call-us-link-center">
                <IonIcon src="assets/icon/contact-us.svg" />
                <span>Contact Us</span>
              </div>
            </span>
          </div>
        } 
        </IonCol>
      </IonRow>
      <IonRow className="group-tab-padding">
        <IonCol size="6">
          {activeTab === "map" && (
            <LoadMap
              shipmentId={props.shipmentId || props.loadId}
              loadStop={sortedLoadStops || []}
              isCarrierLoad={props.isCarrierLoad}
            />
          )}
          {activeTab === "references" && (
            <References references={totalReferences} props={props}/>
          )}
           {activeTab === "services" && (
            <Services services={shipmentServices} props={props}/>
          )}
          {activeTab === "commodities" && (
            <Commodities commodities={commodities} />
          )}
          {activeTab === "pay" && (
            <Pay
              shipmentCostItems={shipmentCostItems}
              costCurrency={costCurrency}
              totalCostAmount={totalCostAmount}
            />
          )}
          {activeTab === "documents" &&
            (documentsListLoader ? (
              <img
                alt="loader"
                src="assets/images/Schneider_Spinner-transparent.gif"
                width="100"
                height="20"
                className="loader-image"
              />
            ) : (
              documentsList !== null && (
                <Documents
                  references={documentsList}
                  userDetails={userDetails}
                  shipmentId={props.shipmentId}
                  sourceTMS={props.sourceTMS}
                  division={props.division}
                  selectedUploadDocumentType={selectedUploadDocumentType}
                  uploadedDocuments={uploadedDocuments}
                  handleFileChange={handleFileChange}
                  handleSelectedUploadDocumentTypeChange={
                    handleSelectedUploadDocumentTypeChange
                  }
                  updateUploadedDocuments={(item: any[]) =>
                    setUploadedDocuments(item)
                  }
                  handleDocumentFetch={handleDocumentFetch}
                  executionStarted={props.executionStatus && props.executionStatus !== "ACCEPTED"}
                  invoiceCreatedDateTime = {props.invoiceCreatedDateTime}
                  isDrayRoute= {props?.isDrayRoute}
                />
              )
            ))}
        </IonCol>
        <IonCol size="5.7" className={"load-stop-details-col"}>
          <div className="load-stop-details">
            {sortedLoadStops.map((stop: any, index: any) => (
              <MyloadStopDetails
                {...props}
                key={index}
                stopDetails={stop}
                appointment={(stop && props.calculateTime(stop)) || ""}
                length={sortedLoadStops.length}
                index={index}
                showExpandView={false}
                isCarrierLoad={false}
                isLoadDetails
              />
            ))}
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  ) : null}
  </>
};

export default LoadTileMap;

